var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c("v-card-text", { staticClass: "pa-0" }, [
        _c(
          "div",
          { ref: "exportTarget" },
          [
            _c(
              "div",
              {
                ref: "exportHeader",
                staticClass: "export-header",
                attrs: { "data-testid": "export-header" },
              },
              [
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.placeName) + " / " + _vm._s(_vm.selectedMonth)
                  ),
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.floorPlanName) + " / " + _vm._s(_vm.filterLabel)
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "v-list",
              { attrs: { dense: "", "data-testid": "item-ranking-list" } },
              [
                _vm._l(_vm.topItems, function (item, index) {
                  return _c(
                    "v-list-item",
                    { key: item.id, staticClass: "ranking-item" },
                    [
                      _c(
                        "v-list-item-icon",
                        { staticClass: "ranking-number-icon" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "ranking-badge",
                              style: { color: _vm.getRankColor(index) },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("rank", { n: index + 1 })) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item-content",
                        [
                          _vm.typeLabel(item)
                            ? _c(
                                "div",
                                {
                                  staticClass: "ranking-type",
                                  attrs: { "data-testid": "item-type-label" },
                                },
                                [_vm._v(_vm._s(_vm.typeLabel(item)))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-list-item-title",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                color: "rgba(0,0,0,0.87)",
                              },
                              attrs: { title: item.label },
                            },
                            [_vm._v(_vm._s(item.label))]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-subtitle",
                            { staticStyle: { color: "rgba(0,0,0,0.6)" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(_vm.type + ".count", {
                                    count: item.count,
                                  })
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _vm.topItems.length === 0
                  ? _c(
                      "v-list-item",
                      [
                        _c(
                          "v-list-item-content",
                          [
                            _c(
                              "v-list-item-title",
                              { staticClass: "text--secondary" },
                              [_vm._v(_vm._s(_vm.$t("no_data")))]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              2
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }